type LoadingListener = (pendingCount: number) => void;

let pendingCount = 0;
let listener: LoadingListener | null = null;

export function registerApiLoading(listenerFn: LoadingListener): void {
  listener = listenerFn;
  listener(pendingCount);
}

export function unregisterApiLoading(): void {
  listener = null;
}

export function incrementApiLoading(): void {
  pendingCount += 1;
  listener?.(pendingCount);
}

export function decrementApiLoading(): void {
  pendingCount = Math.max(0, pendingCount - 1);
  listener?.(pendingCount);
}

